module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/cfb83a43db1bfaaace8ceb06bfab2b05.png";